import { ServiceCheckpointTypeService } from './../../services/service-checkpoint-type-service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { ErrorService } from 'services/error-service';

@autoinject
export class ServiceCheckpiontTypeList {
  private tableData: Array<Models.ServiceCheckpointType>;
  private activeTableRow: number;
  private ready: boolean = false;

  constructor(
    private serviceCheckpointTypeService: ServiceCheckpointTypeService,
    private errorService: ErrorService,
    private router: Router,
    private eventAggregator: EventAggregator
  ) {}

  private activate(params) {
    if (params.Id) {
      this.activeTableRow = params.Id;
    } else {
      this.activeTableRow = 0;
    }
  }

  private attached(params) {
    this.eventAggregator.subscribe('serviceCheckpointTypeListReset', (value) => {
      this.activeTableRow = null;
      return this.updateView();
    });
    this.updateView();
  }

  private updateView() {
    this.serviceCheckpointTypeService
      .getAll('?$expand=ServiceCheckpointGroup&$orderby=ServiceCheckpointGroup/SortIndex,SortIndex')
      .then((res) => {
        this.ready = true;
        this.tableData = res;
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private gotoDetailView(id) {
    this.activeTableRow = id;
    this.router.navigateToRoute('service-checkpoint-type-detail', { Id: id });
  }
}
